// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.category-list[data-v-e441d358] {\n    height: calc(100% - 110px);\n    margin: 0 10px;\n    /* height: 100%; */\n    overflow: auto;\n    position: absolute;\n}\n\n/*.modal-categories{*/\n/*    grid-template-columns: max-content auto 60px;*/\n/*}*/\n", ""]);
// Exports
module.exports = exports;
